<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>流向状态</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['month_range']"
                    type="monthrange"
                    start-placeholder="开始月"
                    end-placeholder="结束月"
                    value-format="yyyy-MM"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 15, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="account_rid"
                    model_name="请输入一级商业搜索"
                    request_uri="searchAccounts"
                    default_option_key="account_option"
                    :default_option="queryParams['account_option']"
                    @onDropChange="onDropChange"
                    ref="account_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="commodity_flow_applicable"
                    model_name="计算类型"
                    select_value="value"
                    request_uri="dropdownCommodityFlowApplicable"
                    :model_value_default="queryParams['commodity_flow_applicable']"
                    @onDropChange="onDropChange"
                    ref="commodity_flow_applicable_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="init_state"
                    model_name="重算状态"
                    select_value="value"
                    request_uri="dropdownPpaState"
                    :model_value_default="queryParams['init_state']"
                    @onDropChange="onDropChange"
                    ref="init_state_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="type"
                    model_name="类型"
                    select_value="value"
                    request_uri="dropdownStateType"
                    :model_value_default="queryParams['type']"
                    @onDropChange="onDropChange"
                    ref="type_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdownMul
                    model_key="data_status_sign"
                    model_name="请选择状态签名"
                    select_value="value"
                    request_uri="dropdownDataStatusSign"
                    :model_value_default="queryParams['data_status_sign']"
                    @onDropChange="onDropChange"
                    ref="data_status_sign_ref"
                ></vDropdownMul>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="recalculate('latest')" :loading="btnLoading">重算最新</el-button>
                <el-button size="small" plain @click="recalculate('all')" :loading="btnLoading">重算所有</el-button>
                <!-- <el-button size="small" plain @click="recalculateFlowExtension()" :loading="btnLoading">重算流向扩展</el-button> -->
                <el-button size="small" plain @click="syncToSf()" :loading="btnLoading">同步到SF流向</el-button>

                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >

                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >重算最新：重算最新一期且为启用的合作产品路径初始化；重算所有：重算所有启用的合作产品路径初始化；重算流向扩展：流向状态重算好以后，会自动进行流向扩展重算（重新折算单条流向的经济指标）；同步到SF流向：将部分重算结果更新到SF</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >如果筛选框有维度相关的筛选(PPA编码、合作方、产品、一级商业)，只对筛选的维度进行重算或同步（立即执行），否则会进入任务队列执行，最新进度会在下方展示</span
                    >
                </div>
                <div class="flex" v-for="(item, index) in taskQueueMessage" :key="index">
                    <span style="color: red; font-size: 13px">
                        {{ item }}
                    </span>
                </div>
            </div>

            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="commodity_flow_state"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['account', 'ppa_code', 'partner', 'product', 'rid'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import vDropdownMul from '@/components/common/dropdown/dropdownMul.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect,
        vDropdownMul
    },
    name: 'commodityFlowStateComponent',
    data() {
        return {
            is_show_help: false,
            draggable: {
                data_name: 'commodity_flow_state'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            taskQueueMessage: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initTaskQueueMessage();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        initTaskQueueMessage() {
            this.$api['taskQueueMessage']({
                code: ['recalculate_ppam_and_flow_extension', 'update_sf_flow']
            })
                .then((res) => {
                    if (res.code == 0) {
                        this.taskQueueMessage = res.data;
                    }
                })
                .catch((error) => {
                    this.taskQueueMessage = [];
                });
        },
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'account' && row.account_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.account_rid
                    }
                });
            } else if (prop == 'product' && row.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (prop == 'partner' && row.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (prop == 'rid' && row.rid != '') {
                this.$router.push({
                    path: '/commodityFlowStateDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'ppa_code' && row.ppa_rid != '') {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: row.ppa_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('commodity_flow_state_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('commodity_flow_state_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('commodity_flow_state', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).commodity_flow_state;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'commodityFlowStateLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        // 重算PPAM
        recalculate(type) {
            this.queryParams.recalculate_type = type;
            this.$confirm('您确定要进行重算吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['commodityFlowStateRecalculate'](this.queryParams)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: res.data,
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        syncToSf() {
            this.$confirm('您确定要同步到SF流向吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['commodityFlowStateToSf'](this.queryParams)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: res.data,
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        reset() {
            this.$refs.partner_rid_ref && this.$refs.partner_rid_ref.reset();
            this.$refs.product_rid_ref && this.$refs.product_rid_ref.reset();
            this.$refs.account_rid_ref && this.$refs.account_rid_ref.reset();
            this.$refs.commodity_flow_applicable_ref && this.$refs.commodity_flow_applicable_ref.reset();
            this.$refs.init_state_ref && this.$refs.init_state_ref.reset();
            this.$refs.type_ref && this.$refs.type_ref.reset();
            this.$refs.data_status_sign_ref && this.$refs.data_status_sign_ref.reset();
            this.initQueryParams();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>